/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import Header from '../../../components/Header';
import Navbar from '../../../components/Navbar/Navbar';
import { Styles } from './styles';
import Banner from '../../../components/Banner/Banner';
import Footer from '../../../components/Footer/Footer';
import { useParams, useNavigate } from 'react-router-dom';
import { slugify } from '@utils/slug';
import HilightAd from '@components/HilightAd/HilightAd';
import BannerCaixa from '@assets/images/banner-caixa.png';
import BannerCadastro from '@assets/images/banner-cadastro.png';
import BannerEncomende from '@assets/images/banner-encomende.png';
import { Stack, useMediaQuery, useTheme } from '@mui/material';
import AppBanner from '@components/Banner/appBanner';
import { IPropertyDetails } from '@stores/Property/types';
import { usePropertyStore } from '@stores/Property/Property';
import PropertyDetailsCard from '@components/PropertyDetailsCard';
import Loading from '@components/Loading/Loading';
import SEO from '@components/SEO';

const PropertyDetailsScreen: React.FC = () => {
  const { fetchPropertyDetails } = usePropertyStore();
  const { propertyId, propertyTitle } = useParams<{
    propertyId: string;
    propertyTitle?: string;
  }>();
  const navigate = useNavigate();
  const [property, setProperty] = useState<IPropertyDetails | null>(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    const fetchData = async () => {
      const propertyData = await fetchPropertyDetails(
        propertyId ? parseInt(propertyId) : 0
      );
      if (propertyData) {
        setProperty(propertyData);
        if (!propertyTitle) {
          navigate(`/imoveis/${propertyId}/${slugify(propertyData.titulo)}`, {
            replace: true
          });
        }
      }
    };
    if (propertyId) {
      fetchData();
    }
  }, [propertyId, propertyTitle, navigate, fetchPropertyDetails]);

  if (!property) {
    return (
      <Styles.Main>
        <Header />
        <Navbar />
        <Styles.MainContainer>
          <Loading showOverlay={false} />
        </Styles.MainContainer>
      </Styles.Main>
    );
  }

  return (
    <Styles.Main>
      <SEO
        title={property.titulo}
        description={
          property.dados_descricao?.descricao
            ? property.dados_descricao.descricao
                .replace(/<[^>]*>/g, '')
                .substring(0, 160)
            : `${property.titulo} - Confira detalhes, fotos e entre em contato.`
        }
        ogType="article"
        ogImage={property.foto_capa}
      />
      <Header />
      <Navbar />
      <Styles.MainContainer>
        <PropertyDetailsCard
          key={propertyId}
          property={property}
          showWhatsappButton={true}
        />
        {!isMobile && (
          <Styles.PRightContainer>
            <HilightAd />
            <Styles.BannerContainer>
              <Stack
                direction="column"
                spacing={2}
                sx={{ justifyContent: 'center', alignItems: 'center' }}>
                <Banner
                  src={BannerCaixa}
                  width={350}
                  height={100}
                  border={false}
                  link={
                    'https://www8.caixa.gov.br/siopiinternet-web/simulaOperacaoInternet.do?method=inicializarCasoUso'
                  }
                />
                <Banner
                  src={BannerCadastro}
                  width={350}
                  height={100}
                  border={false}
                  link={'/cadastrar-imovel'}
                />
                <Banner
                  src={BannerEncomende}
                  width={350}
                  height={100}
                  border={false}
                  link={'/encomendar-imovel'}
                />
              </Stack>
            </Styles.BannerContainer>
          </Styles.PRightContainer>
        )}
      </Styles.MainContainer>

      {isMobile && <AppBanner />}
      <Footer />
    </Styles.Main>
  );
};

export default PropertyDetailsScreen;
